var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehaviorChip3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21.3333,
    height: 21.3333,
    viewBox: "0 0 21.3333 21.3333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scratching"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.79425 1.91859C3.59767 1.73988 3.276 1.72201 3.06155 1.91859C2.8471 2.11517 2.82923 2.45471 3.02581 2.66916L16.1608 16.8942C16.1786 16.9121 16.2144 16.9478 16.2322 16.9657C16.7684 17.4482 17.5904 17.4303 18.0729 16.8942C18.5554 16.3581 18.5376 15.536 18.0014 15.0535L3.79425 1.91859Z",
    fill: "#14CD71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4743 9.34539C15.5279 9.399 15.5815 9.47048 15.653 9.52409C16.207 9.98873 17.0469 9.91725 17.4936 9.34539C17.9583 8.79139 17.8868 7.95147 17.3149 7.50471L10.953 2.21499C10.7564 2.05415 10.4705 2.05415 10.2739 2.21499C10.0416 2.41156 10.0058 2.75111 10.2024 2.96555L15.4743 9.34539Z",
    fill: "#14CD71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08755 9.05639C3.89097 8.87769 3.58717 8.87769 3.37272 9.05639C3.15827 9.25297 3.12253 9.59251 3.31911 9.80696L11.5396 19.1176C11.5754 19.1533 11.6111 19.2069 11.6468 19.2248C12.183 19.7073 13.0229 19.6537 13.4875 19.1176C13.97 18.5815 13.9164 17.7415 13.3803 17.2769L4.08755 9.05639Z",
    fill: "#14CD71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehaviorChip3);
export default __webpack_public_path__ + "static/media/behavior-chip-3.59105780615dc055330ada0f4c3eb742.svg";
export { ForwardRef as ReactComponent };